import React, { useState, useEffect } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyLoader from './util/loader'
import Api from './api/api'
import showToast from './util/toast'
import { ToastContainer } from 'react-toastify';
import { easternWallTimeToEpoch, epochToEasternWallTime, formatEasternNow } from './util/eastern-time';

const SendNotification = () => {
    const location = useLocation()
    const navigate = useNavigate()

    // Set when the admin opens an existing scheduled push from the
    // Scheduled Notifications page (edit), or picks a day on its calendar.
    const model = location.state?.model
    const editMode = model != null
    const presetDateTime = location.state?.scheduledDateTime

    const [title, setTitle] = useState(editMode ? model.title || '' : '');
    const [body, setBody] = useState(editMode ? model.body || '' : '');
    const [loader, setLoader] = useState(false);
    const [isScheduled, setIsScheduled] = useState(editMode || !!presetDateTime);
    const [scheduledDateTime, setScheduledDateTime] = useState(() => {
        if (editMode && model.scheduledAt) return epochToEasternWallTime(model.scheduledAt);
        return presetDateTime || '';
    });

    // Live current Eastern time, so the admin knows "now" while scheduling.
    const [easternNow, setEasternNow] = useState(formatEasternNow());
    useEffect(() => {
        const id = setInterval(() => setEasternNow(formatEasternNow()), 1000);
        return () => clearInterval(id);
    }, []);

    const validate = () => {
        if (title.trim() === '') {
            showToast('error', 'Please enter title!')
            return false
        }
        if (body.trim() === '') {
            showToast('error', 'Please enter body!')
            return false
        }
        if (isScheduled) {
            if (!scheduledDateTime) { showToast('error', 'Select a schedule date & time!'); return false; }
            if (easternWallTimeToEpoch(scheduledDateTime) <= Date.now()) { showToast('error', 'Scheduled time must be in the future!'); return false; }
        }
        return true
    }

    const submit = () => {
        if (!validate()) return

        setLoader(true)

        if (!isScheduled) {
            Api.sendPushToAll(title, body,
                () => {
                    setLoader(false)
                    showToast('success', 'Notification Sent!')
                    if (editMode) {
                        // Sending a scheduled push now replaces its schedule —
                        // drop the pending doc so it doesn't fire again later.
                        Api.deleteScheduledPush(model.id)
                        navigate('/admin/scheduled-notifications')
                    } else {
                        setTitle('')
                        setBody('')
                    }
                },
                () => {
                    setLoader(false)
                    showToast('error', 'Notification Failed!')
                })
            return
        }

        const scheduledAt = easternWallTimeToEpoch(scheduledDateTime)
        const onSuccess = () => {
            setLoader(false)
            showToast('success', editMode ? 'Schedule updated!' : 'Notification Scheduled!')
            navigate('/admin/scheduled-notifications')
        }
        const onError = () => {
            setLoader(false)
            showToast('error', editMode ? 'Update failed!' : 'Scheduling failed!')
        }

        if (editMode) {
            Api.updateScheduledPush(model.id, title, body, scheduledAt, onSuccess, onError)
        } else {
            Api.addScheduledPush(title, body, scheduledAt, onSuccess, onError)
        }
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    {editMode ? 'Edit Scheduled Notification' : 'Send Push Notification'}
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>
                    <FormGroup style={{ marginTop: 0 }}>
                        <Input
                            type='text'
                            placeholder='Notification Title'
                            value={title}
                            onChange={(event) => {
                                setTitle(event.target.value)
                            }} />
                    </FormGroup>
                    <FormGroup style={{ marginTop: 10 }}>
                        <Input
                            type='textarea'
                            placeholder='Notification Body'
                            value={body}
                            onChange={(event) => {
                                setBody(event.target.value)
                            }} />
                    </FormGroup>

                    <FormGroup style={{ marginTop: 15, padding: 15, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #dee2e6' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: isScheduled ? 12 : 0 }}>
                            <input
                                type='checkbox'
                                id='pushScheduleToggle'
                                checked={isScheduled}
                                onChange={e => { setIsScheduled(e.target.checked); if (!e.target.checked) setScheduledDateTime(''); }}
                                style={{ marginRight: 8, width: 16, height: 16, cursor: 'pointer' }}
                            />
                            <Label for='pushScheduleToggle' style={{ margin: 0, cursor: 'pointer', fontWeight: 600 }}>
                                Schedule for later
                            </Label>
                        </div>
                        {isScheduled && (
                            <div>
                                <Label style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>
                                    Date &amp; Time — Eastern Time (users get the push notification at this time)
                                </Label>
                                <div style={{ fontSize: 12, color: '#5c6bc0', marginBottom: 6 }}>
                                    Current Eastern time: <strong>{easternNow}</strong>
                                </div>
                                <Input
                                    type='datetime-local'
                                    value={scheduledDateTime}
                                    min={epochToEasternWallTime(Date.now() + 60000)}
                                    onChange={e => setScheduledDateTime(e.target.value)}
                                />
                            </div>
                        )}
                    </FormGroup>

                    <Button
                        style={{ marginTop: 20, fontSize: 16, backgroundColor: isScheduled ? '#5c6bc0' : undefined, borderWidth: isScheduled ? 0 : undefined }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            submit()
                        }}>
                        {editMode ? 'Update Schedule' : (isScheduled ? 'Schedule Notification' : 'Send Notification')}
                    </Button>

                    <Button
                        style={{ marginTop: 10, fontSize: 14, backgroundColor: 'gray', borderWidth: 0 }}
                        className='btn-block btn-dark'
                        onClick={() => navigate('/admin/scheduled-notifications')}>
                        View Scheduled Notifications
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default SendNotification;
